import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { UsersService } from '../users.service'
import { SELF_ENVIRONMENT, SupportEnvironment } from './support-environment'
import { SupportLink, SupportLinkResolver, SupportResource, supportLinkFor } from './support-link.resolver'

@Injectable()
export class AppSupportLinkResolver extends SupportLinkResolver {
  private usersService = inject(UsersService)

  canFollowSupportLinks(): Observable<boolean> {
    return this.usersService.currentUser$.pipe(map((user) => user?.role === 'SUPPORT'))
  }

  linkTo(environment: SupportEnvironment | undefined, resource: SupportResource, id: number): SupportLink {
    return supportLinkFor(environment ?? SELF_ENVIRONMENT, resource, id)
  }
}
